// extracted by mini-css-extract-plugin
export var container = "_ca-0";
export var popoverContent = "_ca-1";
export var tosLink = "_ca-2";